import { Navigate } from "react-router-dom";
import { useAuth } from "@/fileshare/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireBusiness = false, requireAdmin = false }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="h-6 w-6 text-blue-500 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/fileshares/login" replace />;
  if (requireBusiness && user.tier !== "business") return <Navigate to="/fileshares/pricing" replace />;
  if (requireAdmin && !user.is_admin) return <Navigate to="/fileshares/dashboard" replace />;
  return children;
}
